import React from 'react';
import { Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import Header from '../Header/Header';
import FooterWithImage from '../FooterWithImage/FooterWithImage';
import TellySheetTable from '../TellySheetTable/TellySheetTable';
import { readTenantBranding } from '../../utils/tenantBrandingCache';
import { resolvePdfBrandColors } from '../../utils/pdfBrandColors';

const styles = StyleSheet.create({
  page: {
    fontFamily: 'Helvetica',
    fontSize: 11,
    paddingTop: 24,
    paddingBottom: 24,
    paddingLeft: 48,
    paddingRight: 48,
    lineHeight: 1.35,
    flexDirection: 'column',
  },
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    textAlign: 'center',
    fontStyle: 'bold',
    flexGrow: 1,
    justifyContent: 'space-between',
    borderBottom: 1,
    marginBottom: 10,
  },
});

const TellySheet = ({ tellyData, branding: brandingProp }) => {
  const branding = brandingProp ?? readTenantBranding();
  const { primary } = resolvePdfBrandColors(branding);

  return (
    <Page size='A4' style={styles.page}>
      <Header branding={branding} />
      <View>
        <View style={{ marginTop: '6px' }}>
          <Text style={{ textAlign: 'center', fontSize: 11 }}>TALLY SHEET</Text>
        </View>

        <View
          style={{
            flexDirection: 'row',
            textAlign: 'center',
            border: 1,
            fontSize: 9,
            height: 20,
            marginTop: '4px',
          }}
        >
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ textAlign: 'center', marginVertical: 'auto' }}>CONSIGNOR</Text>
          </View>
          <View style={{ borderRight: 1, width: '30.44%' }}>
            <Text style={{ textAlign: 'center', marginVertical: 'auto' }}>
              {tellyData?.fullName}
            </Text>
          </View>
          <View style={{ borderRight: 1, width: '13%' }}>
            <Text style={{ marginVertical: 'auto' }}>LOCATION</Text>
          </View>
          <View style={{ borderRight: 1, width: '13.33%' }}>
            <Text style={{ marginVertical: 'auto' }}>{tellyData ?.location}</Text>
          </View>
          <View style={{ borderRight: 1, width: '13.33%' }}>
            <Text style={{ marginVertical: 'auto' }}>MODE</Text>
          </View>
          <View style={{ borderRight: 1, width: '13.33%' }}>
            <Text style={{ marginVertical: 'auto' }}>{tellyData ?.mode}</Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: 'row',
            textAlign: 'center',
            borderRight: 1,
            borderLeft: 1,
            fontSize: 9,
            height: 20,
          }}
        >
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ textAlign: 'center', marginVertical: 'auto' }}>GCN NUMBER</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ textAlign: 'center', marginVertical: 'auto' }}>{tellyData ?.gcnno ? tellyData ?.gcnno : tellyData ?.carGcnno}</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>JOB NO.</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>?</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>ORIGIN</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>{tellyData ?.origin}</Text>
          </View>
        </View>

        <View
          style={{
            flexDirection: 'row',
            textAlign: 'center',
            border: '1',
            fontSize: 9,
            height: 20,
          }}
        >
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ textAlign: 'center', marginVertical: 'auto' }}>GCN DATE</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ textAlign: 'center', marginVertical: 'auto' }}>{tellyData ?.date}</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>JOB DATE</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>{tellyData ?.date}</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>DESTINATION</Text>
          </View>
          <View style={{ borderRight: 1, width: '16.66%' }}>
            <Text style={{ marginVertical: 'auto' }}>{tellyData ?.destination}</Text>
          </View>
        </View>

        <View style={{ marginTop: '6px' }}>
          <TellySheetTable />
        </View>
        <View
          style={{
            flexDirection: 'row',
            marginTop: '6px',
          }}
        >
          <View style={{ borderRight: 1, width: '30%' }}></View>
          <View
            style={{
              width: '70%',
              flexDirection: 'row',
              textAlign: 'center',
              border: 1,
              fontSize: 9,
              height: 20,
            }}
          >
            <View style={{ borderRight: 1, width: '25%' }}>
              <Text style={{ textAlign: 'left', marginVertical: 'auto' }}>TOTAL PACKAGES</Text>
            </View>
            <View style={{ borderRight: 1, width: '25%' }}>
              <Text style={{ textAlign: 'center', marginVertical: 'auto' }}></Text>
            </View>
            <View style={{ borderRight: 1, width: '25%' }}>
              <Text style={{ marginVertical: 'auto' }}>VOLUME</Text>
            </View>
            <View style={{ borderRight: 1, width: '25%' }}>
              <Text style={{ marginVertical: 'auto' }}></Text>
            </View>
          </View>
        </View>

        <View
          style={{
            flexDirection: 'row',
          }}
        >
          <View style={{ borderRight: 1, width: '30%' }}></View>
          <View
            style={{
              width: '70%',
              flexDirection: 'row',
              textAlign: 'center',
              borderRight: 1,
              borderLeft: 1,
              fontSize: 9,
              height: 20,
            }}
          >
            <View style={{ borderRight: 1, width: '25%' }}>
              <Text style={{ textAlign: 'left', marginVertical: 'auto' }}>TRUCK NUMBER</Text>
            </View>
            <View style={{ borderRight: 1, width: '75%' }}>
              <Text style={{ textAlign: 'center', marginVertical: 'auto' }}></Text>
            </View>
          </View>
        </View>

        <View
          style={{
            flexDirection: 'row',
          }}
        >
          <View style={{ borderRight: 1, width: '30%' }}></View>
          <View
            style={{
              width: '70%',
              flexDirection: 'row',
              border: 1,
              fontSize: 9,
              height: 20,
            }}
          >
            <View style={{ borderRight: 1, width: '25%' }}>
              <Text style={{ textAlign: 'left', marginVertical: 'auto' }}>ESCORTED BY</Text>
            </View>
            <View style={{ borderRight: 1, width: '75%' }}>
              <Text style={{ textAlign: 'center', marginVertical: 'auto' }}></Text>
            </View>
          </View>
        </View>

        <View
          style={{
            flexDirection: 'row',
            border: 1,
            marginTop: '6px',
            width: '100%',
            height: 52,
          }}
        >
          <Text style={{ textAlign: 'left', padding: '5px', fontSize: 9 }}>Customer: </Text>
        </View>
        <View
          style={{
            flexDirection: 'row',
            borderRight: 1,
            borderLeft: 1,
            borderBottom: 1,
            fontSize: 9,
            height: 40,
          }}
        >
          <View style={{ width: '50%', borderRight: 1 }}>
            <Text style={{ textAlign: 'left', width: '100%', padding: '5px' }}>
              SUPERVISOR'S SIGNATURE
            </Text>
          </View>
          <View style={{ width: '50%' }}>
            <Text style={{ textAlign: 'left', width: '100%', padding: '5px' }}>
              CONSIGNOR'S SIGNATURE
            </Text>
          </View>
        </View>
      </View>
      <View wrap={false}>
        <View style={{ height: 1, backgroundColor: primary, width: '100%', marginTop: 10 }} />
        <FooterWithImage branding={branding} />
      </View>
    </Page>
  );
};

export default TellySheet;
